import {
  differenceInWeeks,
  startOfDay,
  addSeconds,
  startOfWeek,
} from 'date-fns';
import getScheduleDay from 'components/AddWorkSchedule/getScheduleDay';
import weekDays from 'components/CompanyWorkingDays/weekDays';
import { daysInWeek } from 'helpers/timeConsts';

interface GetDayValuesParams {
  startDate: Date;
  isRegularWeek: boolean;
}

export default function getDayValues({
  startDate,
  isRegularWeek,
}: GetDayValuesParams) {
  const day = getScheduleDay({ startDate, isRegularWeek });

  const dayOfWeek = weekDays[day - 1];

  const weekDifference = differenceInWeeks(
    startOfDay(startDate),
    addSeconds(startOfWeek(new Date()), 1),
  );
  const dayWithWeekOffset = isRegularWeek
    ? weekDifference * daysInWeek + day
    : day;

  return {
    day,
    dayOfWeek,
    dayWithWeekOffset,
  };
}
